const state = {
  data: {}
}

export default state